export const geojsonFeatureSchema = {
  type: 'object',
  required: ['type', 'geometry'],
  additionalProperties: false,
  properties: {
    type: {
      type: 'string',
      const: 'Feature',
    },
    id: {
      // Will be ignored
      type: ['string', 'number'],
    },
    properties: {
      type: 'object',
    },
    geometry: {
      type: 'object',
      required: ['type', 'coordinates'],
      additionalProperties: false,
      properties: {
        type: {
          type: 'string',
          enum: ['Point', 'Polygon', 'MultiPolygon'],
        },
        coordinates: {
          oneOf: [
            {
              description: 'Coordinates for a Point',
              type: 'array',
              items: {
                type: 'number',
              },
              minItems: 2,
              maxItems: 2,
            },
            {
              description: 'Coordinates for a Polygon',
              type: 'array',
              items: {
                type: 'array',
                items: {
                  type: 'array',
                  items: {
                    type: 'number',
                  },
                  minItems: 2,
                  maxItems: 2,
                },
                minItems: 4,
              },
              minItems: 1,
            },
            {
              description: 'Coordinates for a MultiPolygon',
              type: 'array',
              items: {
                type: 'array',
                items: {
                  type: 'array',
                  items: {
                    type: 'array',
                    items: {
                      type: 'number',
                    },
                    minItems: 2,
                    maxItems: 2,
                  },
                  minItems: 4,
                },
                minItems: 1,
              },
              minItems: 1,
            },
          ],
        },
      },
    },
  },
};

export const geojsonFeatureCollectionSchema = {
  type: 'object',
  required: ['type', 'features'],
  additionalProperties: false,
  properties: {
    type: {
      type: 'string',
      const: 'FeatureCollection',
    },
    crs: {
      // Will be ignored
      type: 'object',
      additionalProperties: true,
    },
    features: {
      type: 'array',
      items: {
        ...geojsonFeatureSchema,
      },
    },
  },
};
